import http from './httpService';
import {encodeQueryData} from '../../Utils/Common';
const API_URL_IMPORT = process.env.REACT_APP_API_URL_IMPORT;


async function getAllImportList(params:any) {
    const url = `${API_URL_IMPORT}get_all_import_list?`+encodeQueryData(params);
    let response = await http.get(url);
    return response;
}

async function getGenerateAnalysis() {
    const url = `${API_URL_IMPORT}generate_analysis`;
    let response = await http.get(url);
    return response;
}

async function deleteImportData(params:any) {
    const url = `${API_URL_IMPORT}truncate_data`;
    let response = await http.post(url, params);
    return response;
}

async function getValidateData() {
    const url = `${API_URL_IMPORT}clean_data_job`;
    let response = await http.get(url);
    return response;
}

async function transformCustomer(params:any) {
    const url = `${API_URL_IMPORT}transform_data`;
    let response = await http.post(url, params);
    return response;
}

// async function getAllImportErrorList(params: any) {
//     const url = `${API_URL_IMPORT}get_all_import_error_list?` + encodeQueryData(params);
//     let response = await http.get(url);
//     return response;
// }
async function getAllImportCount(params: any) {
    const url = `${API_URL_IMPORT}get_all_import_count?` + encodeQueryData(params);
    let response = await http.get(url);
    return response;
}

const AdministrationImport = {
    getAllImportList,
    deleteImportData,
    getGenerateAnalysis,
    getValidateData,
    transformCustomer,
    // getAllImportErrorList,
    getAllImportCount

};

export default AdministrationImport;